module.exports = __webpack_public_path__ + "img/chofu_play_on.96568a3d.svg";